import React from "react";
import {TextField,} from "@mui/material";

export default function DHTextFieldSmall({id, label, showPlaceholder, width, required, value, disabled, onChange, onKeyDown}) {

    return <TextField id={id}  variant={"standard"} style={{width: width}} required={required}
                      placeholder={showPlaceholder ? label : undefined}
                      label={!showPlaceholder ? label : undefined}
                      value={value} onChange={(event) => onChange(event.target.value)}
                      disabled={disabled}
                      onKeyDown={(e) => {
                          if( onKeyDown !== undefined) {
                              onKeyDown(e);
                          }
                      }}
    />

}